import type { IconSvgObject } from './types';

const ArrowUpRightStackIcon: IconSvgObject = [
  ["path", { d: "M14.9999 19V9H5M14.5714 9.4286L5 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.9999 19V9C18.9999 6.79086 17.2091 5 14.9999 5H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowUpRightStackIcon;
